import { render, staticRenderFns } from "./ThirdStep.vue?vue&type=template&id=4be3ec34&scoped=true&"
import script from "./ThirdStep.vue?vue&type=script&lang=js&"
export * from "./ThirdStep.vue?vue&type=script&lang=js&"
import style0 from "./ThirdStep.vue?vue&type=style&index=0&id=4be3ec34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be3ec34",
  null
  
)

export default component.exports